import { createReducer } from 'services/reduxHelpers'
import { dateTypes } from 'reduxModules/actions/DateActions'

/* ------------- Initial State ------------- */

const initialDate = new Date()
initialDate.setHours(0, 0, 0, 0)

export const initialState = {
  date: initialDate,
  dateRange: [
    initialDate,
    initialDate
  ]
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [dateTypes.SELECT_DATE_ATTEMPT]: (_, { data }) => ({ 
    date: data
  }),

  [dateTypes.SELECT_RANGE_DATE_ATTEMPT]: (_, { data }) => ({ 
    dateRange: data
  })
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/DateReducer.js